module.exports = __webpack_public_path__ + "static/media/IntroThumbnail.e272beb4.png";